// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.school_bundle_tabs.tab-list a {
  color: #fff;
}
.school_bundle_usps,
.school_bundle_usps2 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
}

.school_bundle_usps div {
  display: flex;
  align-items: center;
  width: 50%;
}
.school_bundle_usps div:not(:nth-last-child(-n + 2)) {
  border-bottom: 1px solid #00000024;
  margin-bottom: 20px;
  padding-bottom: 10px;
}
.school_bundle_usps2 div {
  display: flex;
  flex-direction: column;
  /* width: 50%; */
  justify-content: space-around;
}
.school_bundle_usps2 > div {
  flex: 0 1 48%;
  flex-direction: column;
}
.school_bundle_img {
  display: flex;
  flex-direction: column;
  background: #f2f9ff;
  align-items: center;
  height: 100%;
  justify-content: center;
}
.school_bundle_img img {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  object-fit: contain;
}
.school_bundle_img.bundle_middle img {
  width: 70%;
}
.bundle_heading {
  /* font-size: 25px; */
  color: var(--dBlue);
  font-weight: 700;
}
.bundle_heading span {
  color: var(--dPink);
}
.bundle_sub_heading {
  font-size: 14px;
  font-weight: 600;
}
.school_bundle_usps p,
.school_bundle_usps2 h6 {
  font-size: 16px;
  color: rgb(26, 26, 26);
  font-weight: 600;
  margin: 0px;
  margin-left: 10px;
  padding-right: 20px;
}
.school_bundle_usps img {
  width: 45px;
  height: 100%;
  object-fit: contain;
}
.school_bundle_usps2 h6 {
  margin: 0px;
  color: var(--dBlue);
  font-weight: 700;
}
.bundle_heading2 {
  font-size: 18px;
  font-weight: 700;
  color: var(--dPink);
}
.value_offering {
  font-size: 16px;
  color: rgb(90, 90, 90);
  font-weight: bold;
  margin-top: 100px;
}
.value_offering .card_uni {
  padding: 40px;
  border: 1px solid #0cb6fd;
  border-radius: 0px;
  text-align: center;
  box-shadow: 0.954px 4.908px 8px 0px rgba(0, 0, 0, 0.2);
  height: 300px;
}
.value_offering .card_uni img {
  width: 34% !important;
  background: #0cb6fd;
  border-radius: 50%;
  object-fit: contain;
  padding: 20px;
  overflow: visible;
  margin-top: -85px;
}

.bundle_sub_heading2 {
  font-size: 14px;
  color: rgb(90, 90, 90);
  font-weight: 600;
  margin-bottom: 30px;
}

.sec-box-shadow {
  box-shadow: 0px 3px 15px -1px rgb(0 0 0 / 10%);
}

.school_bundle_tabs.tab-list {
  background: none;
  padding-bottom: 50px;
}

.school_bundle_tabs.tab-list a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.school_bundle_tabs.tab-list a li {
  font-size: 40px;
  width: 100%;
  overflow: hidden;
  color: #ffffff;
  text-align: left;
}

.school_bundle_tabs.tab-list a:first-child,
.school_bundle_tabs.tab-list a:nth-child(2),
.school_bundle_tabs.tab-list a:last-child {
  border-radius: 20px;
  box-shadow: 1.782px 0.908px 9px 0px rgba(0, 0, 0, 0.4);
  color: #ffffff;
  text-align: left;
  padding-left: 50px;
}

.school_bundle_tabs.tab-list a:first-child {
  background-color: var(--dBlue) !important;
}

.school_bundle_tabs.tab-list a:nth-child(2) {
  background-color: var(--dPink) !important;
}
.school_bundle_tabs.tab-list a:last-child {
  background-color: rgb(254, 188, 8) !important;
}

.school_bundle_tabs.tab-list a::after {
  content: "1";
  color: #ffffff;
  vertical-align: middle;
  opacity: 0.4;
  font-size: 200px;
  padding-right: 50px;
  font-weight: 700;
}
.school_bundle_tabs.tab-list a:first-child:after {
  content: "1" !important;
}
.school_bundle_tabs.tab-list a:nth-child(2)::after {
  content: "2" !important;
}
.school_bundle_tabs.tab-list a:last-child:after {
  content: "3" !important;
}

.bundle_partner_logo img {
  object-fit: contain;
}

a.bundle_btn {
  background: var(--dBlue);
  color: #ffff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  padding: 7px 15px;
  border-radius: 18px;
}

.psb-sub-heading {
  padding-top: 50px;
}

@media (max-width: 1024px) {
  .bundle_partner_logo .pt-100 {
    padding-top: 30px !important;
  }

  /* .sbi-banner-img {
    bottom: 30% !important;
    left: 2% !important;
    transform: translate(-50%, 56%) !important;
  } */

  /* .sbi-banner-img img {
    height: 400px !important;
    width: auto !important;
  } */
}

@media (max-width: 576px) {
  .school_bundle_usps p,
  .school_bundle_usps2 h6 {
    font-size: 12px;
  }
  .school_bundle_usps img {
    width: 25px;
  }
  .value_offering .card_uni {
    margin-bottom: 55px;
  }
  .school_bundle_tabs.tab-list li:first-child,
  .school_bundle_tabs.tab-list li:nth-child(2),
  .school_bundle_tabs.tab-list li:last-child {
    padding-left: 0px;
  }

  /* .sbi-banner-txt {
    font-size: 16px !important;
    margin-top: 60% !important;
  } */

  /* .sbi-banner-img {
    left: 42% !important;
    transform: translate(-50%, -45%) !important;
  } */

  /* .sbi-banner-img img {
    height: 180px !important;
  } */

  .school_bundle_tabs li {
    padding: 10px !important;
  }

  .school_bundle_tabs.tab-list li::after {
    font-size: 55px !important;
  }

  .school_bundle_tabs.tab-list a {
    font-size: 16px !important;
  }

  .school_bundle_tabs.tab-list {
    flex-direction: column;
  }

  .school_bundle_tabs.tab-list a:first-child,
  .school_bundle_tabs.tab-list a:nth-child(2),
  .school_bundle_tabs.tab-list a:last-child {
    margin-bottom: 30px;
  }

  .school_bundle_tabs.tab-list a li {
    font-size: 30px;
  }

  .school_bundle_tabs.tab-list a::after {
    font-size: 150px;
  }
}

@media screen and (max-width: 992px) and (min-width: 577px) {
  .school_bundle_tabs.tab-list li::after {
    font-size: 110px;
    padding-right: 110px;
  }
  .school_bundle_tabs.tab-list li:first-child,
  .school_bundle_tabs.tab-list li:nth-child(2),
  .school_bundle_tabs.tab-list li:last-child {
    padding-left: 120px;
  }
  .school_bundle_tabs.tab-list li {
    font-size: 30px;
  }
  .value_offering .card_uni img {
    width: 58% !important;
  }
  .value_offering .card_uni {
    height: 400px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .school_bundle_tabs.tab-list a:first-child,
  .school_bundle_tabs.tab-list a:nth-child(2),
  .school_bundle_tabs.tab-list a:last-child {
    padding-left: 40px;
  }

  .school_bundle_tabs.tab-list a li {
    font-size: 26px;
  }

  .school_bundle_tabs.tab-list a::after {
    font-size: 130px;
    padding-right: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SchoolBundleIndia.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,sDAAsD;EACtD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;;;;KAIG;;EAEH;;;KAGG;AACL;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,iBAAiB;EACnB;;EAEA;;;KAGG;;EAEH;;;KAGG;;EAEH;;KAEG;;EAEH;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;;;IAGE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".school_bundle_tabs.tab-list a {\n  color: #fff;\n}\n.school_bundle_usps,\n.school_bundle_usps2 {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.school_bundle_usps div {\n  display: flex;\n  align-items: center;\n  width: 50%;\n}\n.school_bundle_usps div:not(:nth-last-child(-n + 2)) {\n  border-bottom: 1px solid #00000024;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n.school_bundle_usps2 div {\n  display: flex;\n  flex-direction: column;\n  /* width: 50%; */\n  justify-content: space-around;\n}\n.school_bundle_usps2 > div {\n  flex: 0 1 48%;\n  flex-direction: column;\n}\n.school_bundle_img {\n  display: flex;\n  flex-direction: column;\n  background: #f2f9ff;\n  align-items: center;\n  height: 100%;\n  justify-content: center;\n}\n.school_bundle_img img {\n  width: 100%;\n  height: auto;\n  margin-bottom: 30px;\n  object-fit: contain;\n}\n.school_bundle_img.bundle_middle img {\n  width: 70%;\n}\n.bundle_heading {\n  /* font-size: 25px; */\n  color: var(--dBlue);\n  font-weight: 700;\n}\n.bundle_heading span {\n  color: var(--dPink);\n}\n.bundle_sub_heading {\n  font-size: 14px;\n  font-weight: 600;\n}\n.school_bundle_usps p,\n.school_bundle_usps2 h6 {\n  font-size: 16px;\n  color: rgb(26, 26, 26);\n  font-weight: 600;\n  margin: 0px;\n  margin-left: 10px;\n  padding-right: 20px;\n}\n.school_bundle_usps img {\n  width: 45px;\n  height: 100%;\n  object-fit: contain;\n}\n.school_bundle_usps2 h6 {\n  margin: 0px;\n  color: var(--dBlue);\n  font-weight: 700;\n}\n.bundle_heading2 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--dPink);\n}\n.value_offering {\n  font-size: 16px;\n  color: rgb(90, 90, 90);\n  font-weight: bold;\n  margin-top: 100px;\n}\n.value_offering .card_uni {\n  padding: 40px;\n  border: 1px solid #0cb6fd;\n  border-radius: 0px;\n  text-align: center;\n  box-shadow: 0.954px 4.908px 8px 0px rgba(0, 0, 0, 0.2);\n  height: 300px;\n}\n.value_offering .card_uni img {\n  width: 34% !important;\n  background: #0cb6fd;\n  border-radius: 50%;\n  object-fit: contain;\n  padding: 20px;\n  overflow: visible;\n  margin-top: -85px;\n}\n\n.bundle_sub_heading2 {\n  font-size: 14px;\n  color: rgb(90, 90, 90);\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n\n.sec-box-shadow {\n  box-shadow: 0px 3px 15px -1px rgb(0 0 0 / 10%);\n}\n\n.school_bundle_tabs.tab-list {\n  background: none;\n  padding-bottom: 50px;\n}\n\n.school_bundle_tabs.tab-list a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.school_bundle_tabs.tab-list a li {\n  font-size: 40px;\n  width: 100%;\n  overflow: hidden;\n  color: #ffffff;\n  text-align: left;\n}\n\n.school_bundle_tabs.tab-list a:first-child,\n.school_bundle_tabs.tab-list a:nth-child(2),\n.school_bundle_tabs.tab-list a:last-child {\n  border-radius: 20px;\n  box-shadow: 1.782px 0.908px 9px 0px rgba(0, 0, 0, 0.4);\n  color: #ffffff;\n  text-align: left;\n  padding-left: 50px;\n}\n\n.school_bundle_tabs.tab-list a:first-child {\n  background-color: var(--dBlue) !important;\n}\n\n.school_bundle_tabs.tab-list a:nth-child(2) {\n  background-color: var(--dPink) !important;\n}\n.school_bundle_tabs.tab-list a:last-child {\n  background-color: rgb(254, 188, 8) !important;\n}\n\n.school_bundle_tabs.tab-list a::after {\n  content: \"1\";\n  color: #ffffff;\n  vertical-align: middle;\n  opacity: 0.4;\n  font-size: 200px;\n  padding-right: 50px;\n  font-weight: 700;\n}\n.school_bundle_tabs.tab-list a:first-child:after {\n  content: \"1\" !important;\n}\n.school_bundle_tabs.tab-list a:nth-child(2)::after {\n  content: \"2\" !important;\n}\n.school_bundle_tabs.tab-list a:last-child:after {\n  content: \"3\" !important;\n}\n\n.bundle_partner_logo img {\n  object-fit: contain;\n}\n\na.bundle_btn {\n  background: var(--dBlue);\n  color: #ffff;\n  width: fit-content;\n  padding: 7px 15px;\n  border-radius: 18px;\n}\n\n.psb-sub-heading {\n  padding-top: 50px;\n}\n\n@media (max-width: 1024px) {\n  .bundle_partner_logo .pt-100 {\n    padding-top: 30px !important;\n  }\n\n  /* .sbi-banner-img {\n    bottom: 30% !important;\n    left: 2% !important;\n    transform: translate(-50%, 56%) !important;\n  } */\n\n  /* .sbi-banner-img img {\n    height: 400px !important;\n    width: auto !important;\n  } */\n}\n\n@media (max-width: 576px) {\n  .school_bundle_usps p,\n  .school_bundle_usps2 h6 {\n    font-size: 12px;\n  }\n  .school_bundle_usps img {\n    width: 25px;\n  }\n  .value_offering .card_uni {\n    margin-bottom: 55px;\n  }\n  .school_bundle_tabs.tab-list li:first-child,\n  .school_bundle_tabs.tab-list li:nth-child(2),\n  .school_bundle_tabs.tab-list li:last-child {\n    padding-left: 0px;\n  }\n\n  /* .sbi-banner-txt {\n    font-size: 16px !important;\n    margin-top: 60% !important;\n  } */\n\n  /* .sbi-banner-img {\n    left: 42% !important;\n    transform: translate(-50%, -45%) !important;\n  } */\n\n  /* .sbi-banner-img img {\n    height: 180px !important;\n  } */\n\n  .school_bundle_tabs li {\n    padding: 10px !important;\n  }\n\n  .school_bundle_tabs.tab-list li::after {\n    font-size: 55px !important;\n  }\n\n  .school_bundle_tabs.tab-list a {\n    font-size: 16px !important;\n  }\n\n  .school_bundle_tabs.tab-list {\n    flex-direction: column;\n  }\n\n  .school_bundle_tabs.tab-list a:first-child,\n  .school_bundle_tabs.tab-list a:nth-child(2),\n  .school_bundle_tabs.tab-list a:last-child {\n    margin-bottom: 30px;\n  }\n\n  .school_bundle_tabs.tab-list a li {\n    font-size: 30px;\n  }\n\n  .school_bundle_tabs.tab-list a::after {\n    font-size: 150px;\n  }\n}\n\n@media screen and (max-width: 992px) and (min-width: 577px) {\n  .school_bundle_tabs.tab-list li::after {\n    font-size: 110px;\n    padding-right: 110px;\n  }\n  .school_bundle_tabs.tab-list li:first-child,\n  .school_bundle_tabs.tab-list li:nth-child(2),\n  .school_bundle_tabs.tab-list li:last-child {\n    padding-left: 120px;\n  }\n  .school_bundle_tabs.tab-list li {\n    font-size: 30px;\n  }\n  .value_offering .card_uni img {\n    width: 58% !important;\n  }\n  .value_offering .card_uni {\n    height: 400px;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .school_bundle_tabs.tab-list a:first-child,\n  .school_bundle_tabs.tab-list a:nth-child(2),\n  .school_bundle_tabs.tab-list a:last-child {\n    padding-left: 40px;\n  }\n\n  .school_bundle_tabs.tab-list a li {\n    font-size: 26px;\n  }\n\n  .school_bundle_tabs.tab-list a::after {\n    font-size: 130px;\n    padding-right: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
